import React from "react";
import {
  HardHat,
  Building2,
  Ruler,
  Hammer,
  House
} from "lucide-react";

import ProfessionCard from "./ProfessionCard";
import "./profession.dashboard.css";

export default function ProfessionCategories({
  onSelect,
  data = []
}) {
  const roles = [
    {
      title: "Worker",
      icon: HardHat,
      color: "#f97316"
    },
    {
      title: "Engineer",
      icon: Building2,
      color: "#0a66c2"
    },
    {
      title: "Architect",
      icon: Ruler,
      color: "#8b5cf6"
    },
    {
      title: "Contractor",
      icon: Hammer,
      color: "#d97706"
    },
    {
      title: "Real Estate Dealer",
      icon: House,
      color: "#16a34a"
    }
  ];

  return (
    <div className="category-grid">
      {roles
        .filter((role) =>
          data.some(
            (profession) =>
              profession._id === role.title
          )
        )
        .map((role) => (
          <ProfessionCard
            key={role.title}
            title={role.title}
            icon={role.icon}
            color={role.color}
            onClick={() => onSelect(role.title)}
          />
        ))}
    </div>
  );
}